import { useContext, useState } from "react"
import { useNavigate } from "react-router-dom"
import utility, { handleTypeNumberControl } from "src/utils/utility"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import ApiContext from "src/provider/API/call-service"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import UserContext from "src/provider/state-manager/userProvider"
import { AppLink, AppText, AuthOtpLabel, Button, CustomContainer, FlexRow, Form, GridContainer, ScreenTitle } from "src/style"
import { AccountDeletionContainer } from "src/component"
import helpers from "src/utils/helpers"
import ResendIcon from 'src/assets/svg/resend-otp-icon'

const OtpValidation = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {user, setUserProperty} = useContext(UserContext)
    const {notifier} = useContext(VisibilityContext)
    const {info: {institutionData}} = useContext(AppInfoContext)
    const [otp, setOtp] = useState('')

    const acctDeletionFlowType = utility.getAccountDeletionFlowType()
    
    const handlePin = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.length < 7) {
            setOtp(e.target.value)
        }
    }

    function handleResendOtp() {
        API.sendProfileDeactivationOtp()
    }

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()

        if (otp.length != 6) return notifier.show('Kindly provide a valid Otp', 'Validation Response')
        const hashedOtp = helpers.hashString(otp)

        await setUserProperty('acctDeletionData', {...user.acctDeletionData, otp: hashedOtp})
        const response = await API.deactivateProfile(hashedOtp)
        if (response) navigate(acctDeletionFlowType === 'alias' ? `/${institutionData.alias}/account-deletion/delete-completion` : '/account-deletion/delete-completion')
    }
    
    return (
        <>
            <AccountDeletionContainer>
                <CustomContainer>
                    <ScreenTitle textSize="2.2" fontWeight="700" align="center">One Time Password</ScreenTitle>
                    <AppText align="center" topMargin="2.5" bottomMargin="2">
                        To confirm your identity please enter the OTP sent to your registered registered phone number and email
                    </AppText>
                    
                    
                    <Form onSubmit={handleProceed} topMargin='2'>
                        <GridContainer>
                            <FlexRow 
                                width="auto" sizeUnit="" gap='1.4'
                                className="auth-otp-flex"
                            >
                                <input 
                                    className='display-hidden' id='code' 
                                    name="otp" value={otp}
                                    onChange={handlePin} 
                                    onKeyDown={handleTypeNumberControl}
                                    onKeyUp={handleTypeNumberControl}
                                    autoFocus={true} autoComplete="off"
                                />
                                <AuthOtpLabel className={`${otp.length === 0 ? 'active-otp-box' : ''}`} htmlFor='code' >{otp[0] ? '*' : ''}</AuthOtpLabel>
                                <AuthOtpLabel className={`${otp.length === 1 ? 'active-otp-box' : ''}`} htmlFor='code' >{otp[1] ? '*' : ''}</AuthOtpLabel>
                                <AuthOtpLabel className={`${otp.length === 2 ? 'active-otp-box' : ''}`} htmlFor='code' >{otp[2] ? '*' : ''}</AuthOtpLabel>
                                <AuthOtpLabel className={`${otp.length === 3 ? 'active-otp-box' : ''}`} htmlFor='code' >{otp[3] ? '*' : ''}</AuthOtpLabel>
                                <AuthOtpLabel className={`${otp.length === 4 ? 'active-otp-box' : ''}`} htmlFor='code' >{otp[4] ? '*' : ''}</AuthOtpLabel>
                                <AuthOtpLabel className={`${otp.length >= 5 ? 'active-otp-box' : ''}`} htmlFor='code' >{otp[5] ? '*' : ''}</AuthOtpLabel>
                            </FlexRow>
                        </GridContainer>
                        <GridContainer
                            bgColor='#E7F6F5' minHeight='6.2' radius='0.8'
                            shadow='0px 1px 2px rgba(16, 24, 40, 0.05)'
                            padding='2' topPadding='1' bottomPadding='1'
                            topMargin='2.5'
                        >
                            <FlexRow gap='1.5' className='test-safari'>
                                <ResendIcon className='icon-component' />
                                <AppText textSize='1.2' color='#0A756F'>
                                    Did not receive OTP.
                                    <AppLink 
                                        textSize='1.2' color='#0A756F' fontWeight='700' 
                                        hoverColor='#000000' leftMargin="0.5"
                                        onClick={handleResendOtp}
                                    > 
                                        Tap here to resend 
                                    </AppLink> 
                                </AppText>
                            </FlexRow>
                        </GridContainer>
                        <FlexRow justifyContent='flex-end' gap='1.5' topMargin='2' >
                            <Button 
                                width='6.7' height='4' bgColor="#ffffff"
                                borderColor='#D0D5DD' hoverBgColor='#ffffff' 
                                hoverColor='#0D968F' titleSize='1.4' color="#344054"
                                onClick={() => navigate(acctDeletionFlowType === 'alias' ? `/${institutionData.alias}/account-deletion/reason` : '/account-deletion/reason')}
                            >
                                Back
                            </Button>
                            <Button 
                                width='8.8' height='4'
                                borderColor='#0D968F' hoverBgColor='#fff' 
                                hoverColor='#0D968F' titleSize='1.4'
                            >
                                Proceed
                            </Button>
                        </FlexRow>
                    </Form>
                </CustomContainer>
            </AccountDeletionContainer>
        </>
    )
}

export default utility.routeData('otp-validation', 'OTP Validation', <OtpValidation/>)